import { render, staticRenderFns } from "./FreePlanSettingsCard.vue?vue&type=template&id=0895be3a"
import script from "./FreePlanSettingsCard.vue?vue&type=script&lang=js"
export * from "./FreePlanSettingsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports